Vue.component('guestflip-welcome', {
  props: ['user', 'context'],

  data() {
    return {
      search: null,
      currentStep: 1,
      steps: [
        'Search your hotel',
        'Enter property name',
        'Confirm TripAdvisor Link',
        'Enter number of rooms',
        'Ready, set, go!'
      ],
      hotelName: '',
      tripAdvisorDisabled: true,
      tripAdvisorUrl: '',
      numberOfRooms: 0,
      propertySelected: false,
      tripAdvisorInput: false,
      tripAdvisorOverview: null,
      isFormBusy: false
    }
  },

  computed: {
    listingId() {

      listingIdRegex = /-d([0-9]+)-/gm

      reg = listingIdRegex.exec(this.tripAdvisorUrl)

      if (reg) {
        return reg[1]
      }

      return null
    },
    ogImage() {
      if (this.tripAdvisorOverview && this.tripAdvisorOverview.open_graph_image) {
        return this.tripAdvisorOverview.open_graph_image
      } else {
        return '/img/reviews/trip_advisor_light.png'
      }
    }
  },

  methods: {
    switchToStep(num) {
      this.currentStep = num
      if (num == 2) {
        document.querySelector('body').classList.add('working')
      }
      if (num == 6) {
        document.querySelector('body').classList.remove('working')
        document.querySelector('body').classList.add('final-illustration')
      }
    },
    stepStatus(num) {

      if (num < this.currentStep || this.currentStep == 6) {
        return 'completed'
      }

      if (num == this.currentStep) {
        return 'active'
      }


      return 'inactive'

    },
    startSetUp(event) {

      this.switchToStep(2)

      analytics.track("Started Onboarding")

    },
    pasteTripAdivsorUrl(event) {

      this.tripAdvisorUrl = event.clipboardData.getData('text')
      this.selectHotel()

    },
    selectHotel() { 

      if (this.listingId) {
        this.tripAdvisorOverview = 'loading'
        this.getMetaData(this.listingId)
      }

      analytics.track("Found Property In Onboarding", {
        trip_advisor_listing_id: this.listingId
      })

    },
    setPreferredName() {
      
      this.switchToStep(4)

      analytics.track("Set Preferred Name In Onboarding", {
        trip_advisor_listing_id: this.listingId
      })

    },
    confirmTripAdvisor() {
      // this.numberOfRooms = 200
      this.switchToStep(5)

      analytics.track("Confirmed TripAdvisor In Onboarding", {
        trip_advisor_listing_id: this.listingId
      })

    },
    roomsSubtract() {
      if (this.numberOfRooms === '') {
        this.numberOfRooms = 0
        return
      }

      this.numberOfRooms = parseInt(this.numberOfRooms) - 1
      if (this.numberOfRooms < 0) this.numberOfRooms = 0
    },
    roomsAdd() {
      if (this.numberOfRooms === '') this.numberOfRooms = 0
      this.numberOfRooms = parseInt(this.numberOfRooms) + 1
    },
    confirmRooms() {
      this.switchToStep(6)

      analytics.track("Confirmed Number Of Rooms In Onboarding", {
        trip_advisor_listing_id: this.listingId
      })

    },
    getMetaData(listingId) {

      axios.get('/api/trip-advisor/overview?listing_id=' + listingId)
      .then(response => {
        console.log("JUST GOT DATA LOL")
        this.tripAdvisorOverview = response.data
        this.numberOfRooms = response.data.number_of_rooms
        this.switchToStep(3)
      }).catch(error => {
        console.log(error)
      })

    },
    selectAlgoliaItem(item) {
      elem = document.getElementById('ais-autocomplete').querySelector('input')
      elem.value = item.name
      elem.dispatchEvent(new Event('input'))
      this.hotelName = item.name
      this.propertySelected = true
      this.tripAdvisorUrl = item.trip_advisor_url
    },
    enterTripAdvisorLink() {
      this.tripAdvisorInput = true
    },
    completeAccount() {
      // analytics.track("Created New Hotel")

      // this.isFormBusy = true

    }
  },

  mounted() {

    this.tripAdvisorInput = true

    // Identify users who go through the onboarding phase in Segment
    analytics.identify(this.user.id, {
      email: this.user.email,
      name: this.user.name
    })

  }

})